/** 运输委托单运价费用自动带入提示状态（与后端 TransportConsignmentFeeAutoImportStatusEnum 一致） */
export const FEE_AUTO_IMPORT_HINT_STATUS = {
  PARTIAL: 'PARTIAL',
  FAILED: 'FAILED'
} as const

/** 运输委托单运价费用自动带入执行结果（与后端 TransportConsignmentFeeAutoImportStatusEnum 一致） */
export const FEE_AUTO_IMPORT_RESULT_STATUS = {
  SUCCESS: 'SUCCESS',
  PARTIAL: 'PARTIAL',
  FAILED: 'FAILED',
  SKIPPED_HAS_FEES: 'SKIPPED_HAS_FEES',
  SKIPPED_NO_QUOTATION: 'SKIPPED_NO_QUOTATION',
  SKIPPED_PRICE_UNCONFIRMED: 'SKIPPED_PRICE_UNCONFIRMED'
} as const

/** 运输委托单费用确认状态（与后端 TransportConsignmentFeeAutoImportConstants 一致） */
export const FEE_CONFIRM_STATUS = {
  UNCONFIRMED: 0,
  CONFIRMED: 1
} as const

/** 费用方向（与后端 order_fee.fee_type 一致） */
export const ORDER_FEE_TYPE = {
  RECEIVABLE: 1,
  PAYABLE: 2
} as const
export type OrderFeeType = typeof ORDER_FEE_TYPE[keyof typeof ORDER_FEE_TYPE]

/** 费用归属单据类型（与后端 ShokzBillTypeEnum 一致） */
export const ORDER_FEE_BILL_TYPE = {
  DISTRIBUTION_SHIPMENT: 1,
  TRANSPORT_ENTRUST: 3
} as const

/** 国内/国外标识（与后端 OrderFeeConstants 一致） */
export const ORDER_FEE_DOMESTIC_FOREIGN = {
  DOMESTIC: 1,
  FOREIGN: 2
} as const

/** 费用核销状态（与后端 OrderFeeConstants 一致） */
export const ORDER_FEE_WRITE_OFF_STATUS = {
  UNWRITTEN: 0,
  WRITTEN: 1,
  PARTIAL: 2
} as const

/** 费用对账状态（与后端 OrderFeeConstants 一致） */
export const ORDER_FEE_RECONCILIATION_STATUS = {
  UNCHECKED: 0,
  CHECKED: 1,
  REJECTED: 2
} as const

/** 费用推送状态（与后端 OrderFeeConstants 一致） */
export const ORDER_FEE_PUSH_STATUS = {
  UNPUSHED: 0,
  PUSHED: 1
} as const

/** 费用是否参与结算标识（与后端 order_fee.settlement_flag 一致） */
export const ORDER_FEE_SETTLEMENT_FLAG = {
  YES: 'Y',
  NO: 'N'
} as const

export type FeeAutoImportHintStatus =
  typeof FEE_AUTO_IMPORT_HINT_STATUS[keyof typeof FEE_AUTO_IMPORT_HINT_STATUS]
export type FeeAutoImportResultStatus =
  typeof FEE_AUTO_IMPORT_RESULT_STATUS[keyof typeof FEE_AUTO_IMPORT_RESULT_STATUS]
